module.exports = __webpack_public_path__ + "img/uk-other-heart-diseases-female.008cec5d.png";